'use client'
import cl from 'clsx'
import Button from '@/ui/button'
import Title from '@/ui/title'
import Link from 'next/link'
import { ScrollPanel } from 'primereact/scrollpanel'

import styles from './styles.module.css'
import './styles.css'

export default function How({ dict }) {
    const {
        title,
        firstLine,
        secondLine,
        description_1,
        li_1,
        li_2,
        li_3,
        li_4,
        li_5,
        li_6,
        li_7,
        li_8,
        li_9,
        description_2,
        about_us_label
    } = dict.how

    return (
        <section id="how" className={styles.how}>
            <div className={cl(styles.how__content_wrapper, 'container')}>
                <div className={styles.how__content}>
                    <Title
                        title={title}
                        firstLine={firstLine}
                        secondLine={secondLine}
                        width="794px"
                        color="white"
                        position="how"
                    />

                    <div className={styles.how__description_wrapper}>
                        <div className={styles.how__description_wrapper_content}>
                            <ScrollPanel style={{ width: '100%', height: '200px' }} className="custombar2">
                                <div className={styles.how__description_block}>
                                    <p className={styles.how__description}>{description_1}</p>
                                    <ul className={styles.how__description_list}>
                                        <li className={styles.how__description_list_item}>{li_1}</li>
                                        <li className={styles.how__description_list_item}>{li_2}</li>
                                        <li className={styles.how__description_list_item}>{li_3}</li>
                                        <li className={styles.how__description_list_item}>{li_4}</li>
                                        <li className={styles.how__description_list_item}>{li_5}</li>
                                        <li className={styles.how__description_list_item}>{li_6}</li>
                                        <li className={styles.how__description_list_item}>{li_7}</li>
                                        <li className={styles.how__description_list_item}>{li_8}</li>
                                        <li className={styles.how__description_list_item}>{li_9}</li>
                                    </ul>
                                    <p className={styles.how__description}>{description_2}</p>
                                </div>
                            </ScrollPanel>
                        </div>

                        <div className={styles.how__buttons_wrapper}>
                            <Link href="https://ic-ces.at/about/" target="_blank">
                                <Button type="how-arrow" externalText={about_us_label} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.how__video_overlay}></div>

            <video
                className={styles.how_video}
                width="320"
                height="240"
                controls={false}
                preload="none"
                autoPlay
                loop
                muted
                playsInline
            >
                <source src="/video/how.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </section>
    )
}
